import React from "react";

interface Content {
    headline: string;
    text: string;
    el:string;
}

const BigHeadline = (props: Content) => {
  const {headline, text, el} = props;

  return (
    <>
      <div className={`big-headline ${el}`}>
        {(headline || text) &&
          <div  className="big-headline__content">
            <div className="big-headline__headline">
              <p className="hl-1"  dangerouslySetInnerHTML={{ __html: headline || '' }}/>
            </div>
            { text &&
              <div className="big-headline__text"   dangerouslySetInnerHTML={{ __html: text || '' }}/>
            }
          </div>
        }
      </div>
    </>
  )
};

export default BigHeadline;
